var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0004 5.96663C14.9504 5.9583 14.8921 5.9583 14.8421 5.96663C13.6921 5.92496 12.7754 4.98329 12.7754 3.81663C12.7754 2.62496 13.7337 1.66663 14.9254 1.66663C16.1171 1.66663 17.0754 2.63329 17.0754 3.81663C17.0671 4.98329 16.1504 5.92496 15.0004 5.96663Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1422 12.0333C15.2839 12.225 16.5422 12.025 17.4255 11.4333C18.6005 10.65 18.6005 9.36664 17.4255 8.58331C16.5339 7.99164 15.2589 7.79163 14.1172 7.99163",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97442 5.96663C5.02442 5.9583 5.08275 5.9583 5.13275 5.96663C6.28275 5.92496 7.19941 4.98329 7.19941 3.81663C7.19941 2.62496 6.24108 1.66663 5.04942 1.66663C3.85775 1.66663 2.89941 2.63329 2.89941 3.81663C2.90775 4.98329 3.82442 5.92496 4.97442 5.96663Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83255 12.0333C4.69088 12.225 3.43255 12.025 2.54922 11.4333C1.37422 10.65 1.37422 9.36664 2.54922 8.58331C3.44089 7.99164 4.71588 7.79163 5.85755 7.99163",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 12.1917C9.95039 12.1834 9.89206 12.1834 9.84206 12.1917C8.69206 12.1501 7.77539 11.2084 7.77539 10.0417C7.77539 8.85006 8.73372 7.89172 9.92539 7.89172C11.1171 7.89172 12.0754 8.85839 12.0754 10.0417C12.0671 11.2084 11.1504 12.1584 10.0004 12.1917Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57559 14.8166C6.40059 15.5999 6.40059 16.8832 7.57559 17.6666C8.90892 18.5582 11.0923 18.5582 12.4256 17.6666C13.6006 16.8832 13.6006 15.5999 12.4256 14.8166C11.1006 13.9332 8.90892 13.9332 7.57559 14.8166Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/peopleIcon.d430d66b7349c03eff342df69472675a.svg";
export { ForwardRef as ReactComponent };